export default "__VITE_ASSET__Bz4SYn_x__"